module.exports = __webpack_public_path__ + "img/2015046.319fde24.svg";